import React from "react";

const FormItemQuantity = ({
  itemId,
  maxQuantity,
  quantity,
  isOptionSelected,
  isDepositFeesItem,
  onQuantityChange,
}) => {
  return (
    <div className="col-span-3 flex flex-col-reverse">
      <input
        type="number"
        min="0"
        max={maxQuantity}
        value={quantity || ""}
        onChange={(e) => onQuantityChange(itemId, e.target.value)}
        disabled={!isOptionSelected || isDepositFeesItem}
        className={
          "w-full p-2 border rounded text-center" +
          (isDepositFeesItem ? " border-gray-300" : "")
        }
      />
      <span className="text-xs text-center">Quantity</span>
    </div>
  );
};

export default FormItemQuantity;
